import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface StatusTagContainerProps {
  color: string;
  backgroundColor: string;
}

export const StatusTagContainer = styled(Box)<StatusTagContainerProps>(
  ({ color, backgroundColor, theme }) => ({
    display: 'inline-flex',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1, 3),
    borderRadius: '46px',
    color: color,
    backgroundColor: backgroundColor,
  }),
);
